import Notification from 'src/resources/elements/Notification'
import { ButtonBase } from 'src/resources/elements/buttons/FlatButton'
import { useTranslation } from 'react-i18next'

interface IRecordStatusBanner {
  recordSuccessCount: number
  recordRejectedCount: number
  onDiscard?: () => void
}

export function RecordStatusBanner({
  recordSuccessCount,
  recordRejectedCount,
  onDiscard
}: IRecordStatusBanner) {
  const { t } = useTranslation()

  return (
    <Notification
      fullWidth
      showIcon={false}
      type='info'
      title={
        t('components.RecordStatusBanner.titleSuccess', { count: recordSuccessCount }) +
        t('components.RecordStatusBanner.titleRejected', {
          count: recordRejectedCount
        })
      }
      button={
        onDiscard && (
          <ButtonBase data-testid='dismiss-button' onClick={onDiscard}>
            {t('components.RecordStatusBanner.discardAndFinish')}
          </ButtonBase>
        )
      }
    >
      {t('components.RecordStatusBanner.rejectedDescription', {
        count: recordRejectedCount
      })}
    </Notification>
  )
}
